import { render, staticRenderFns } from "./DriverAssignmentRequestsView.vue?vue&type=template&id=943bb1c8&lang=pug"
import script from "./DriverAssignmentRequestsView.vue?vue&type=script&lang=js"
export * from "./DriverAssignmentRequestsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports